import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalCloseButton,
    Text,
} from '@chakra-ui/react';
import React from 'react';

export interface InvoiceVendorSuggestionModalProps {
    isOpen: boolean;
    onClose: () => void;
    suggestedVendorName: string;
    onAccept: () => void;
}

export default function InvoiceVendorSuggestionModal(props: InvoiceVendorSuggestionModalProps) {
    const { isOpen, onClose, suggestedVendorName, onAccept } = props;
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Vendor name mismatch</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="sm" color="gray.600">
                        The vendor name does not match the NEX purchase order. Did you mean <strong>{suggestedVendorName}</strong>?
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button size="action" variant="outlineGray" mr={3} onClick={onClose}>Cancel</Button>
                    <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onAccept}>Accept correction</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
